export const iconFontAwesomeLogisticsBridgeCircleCheck = (
	<i className="fa-solid fa-bridge-circle-check"></i>
);
